(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('e404', e404);

    /* @ngInject */
    function e404() {

        var directive = {
            bindToController: true,
            templateUrl: '404.tpl',
            controller: e404Controller,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
            }
        };
        return directive;

        /////////////////

        function link(scope, element, attrs) {
        }

    }

    /* @ngInject */
    function e404Controller() {
    }

})();